export default __webpack_public_path__ + "media/images/admin/chevron-down-90f162e6ef71c00753f4e5cc3efaf754.svg";